import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=295f5b03&"
import script from "./doctor.vue?vue&type=script&lang=js&"
export * from "./doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports